import React from "react";
import { HEXCheckIcon } from "@icons/hexpert/HEXCheckIcon";
import './ProductListItem.scss';

export type ProductListItemProps = {
  text?: string;
};

export const ProductListItem = ({ text }: ProductListItemProps) => {
  return (
    <div className="c-hex-product-list-item">
      <div className="c-hex-product-list-item-check">
        <HEXCheckIcon />
      </div>
      <p className="c-hex-product-list-item-text">{text}</p>
    </div>
  );
};

export default ProductListItem;
